import { memo } from 'react';
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import { Text } from 'react-internationalization'

const QuotaWarning = memo(props => {
  return (
    <Dialog
      open={props.open}
      onClose={props.handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description">
      <DialogTitle id="alert-dialog-title">
        <Text id="quota_warning_title" />
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <Text id="quota_warning_text" values={{ percent: props.percent }} />
        </DialogContentText>
        <br />
        <DialogContentText id="alert-dialog-description">
          <Text id="quota_warning_text_hint" />
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.handleClose} color="primary">
          <Text id="ok" />
        </Button>
      </DialogActions>
    </Dialog>
  )
})

export default QuotaWarning
